import React from 'react'
import { Modal } from '../../../components/_EOS/Modal'
import { ModalReturnType } from '../../../hooks/useModal'
import { Asn } from '../../../interfaces/Asn/Asn'
import { GridLpnState } from '../../../components/ASN/GridLpnState/GridLpnStateElements'

interface ASNLpnStateModalProps {
  lpnStateModal: ModalReturnType<Asn>
}

export const ASNLpnStateModal: React.FC<ASNLpnStateModalProps> = ({
  lpnStateModal
}) => {
  return (
    <Modal
      open={lpnStateModal.isOpen}
      maxWidth={lpnStateModal.size}
      title={lpnStateModal.title}
      onClose={lpnStateModal.closeModal}
    >
      {lpnStateModal.extendedProps && (
        <GridLpnState
          asnId={lpnStateModal.extendedProps.asnId}
        />
      )}
    </Modal>
  )
}

